import React, { Component } from "react";
import { Row,Col, Dropdown, DropdownButton, Image } from "react-bootstrap";
 
class AdminSpecificTutor extends Component
{
    


    constructor()
    {

        super();
        this.state = {
            value: "",
            values:["Set Status","Approved"],
            activetab:0,
        }

    }

    render(){

        const { activetab, value, values } = this.state;

        return(
            <div className="container">
                <div className="admin-specific-tutor">
                        <div className="sub-nav-btn">
                            <button >Back</button>
                            <button ><i className="fa fa-edit"></i>Edit</button>
                            <button >Availability</button>
                            <button ><i className="fa fa-trash"></i>Delete</button>
                            <button >Set Status<i className="fa fa-caret-down"></i></button>
                            <button ><i className="fa fa-envelope"></i>Set one off Email</button>
                            <button >Resend Welcome Email</button>
                            <button >Label<i className="fa fa-caret-down"></i></button>
                        </div>

                </div>
            <Row className="m-0">
                 <Col lg={4} md={12} sm={12} xs={12} className="admin-profile-card-col p-0">
                         
                     <Row className="m-0">
                        <div>
                            <button>APPROVED</button>
                            <img src="https://images.unsplash.com/photo-1603383812511-83da9a98b22f?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1050&q=80" alt="Italian Trulli"/>
                        </div>
                     </Row>
                     <Row className="m-0">
                        <table>
                                <tr>
                                    <th>Personal Details</th>
                                    <th></th>
                                </tr>

                                <tr>
                                    <td className = "makingbold" >Full Name</td>
                                    <td   >Ahmad Farooq</td>
                                </tr>
                                <tr>
                                    <td  className = "makingbold">Gender</td>
                                    <td   >Male</td>
                                </tr>
                                <tr>
                                    <td  className = "makingbold">Date of birth</td>
                                    <td   >15 May 2000</td>
                                </tr>
                                <tr>
                                    <td  className = "makingbold">ID</td>
                                    <td   >15 May 2000</td>
                                </tr>
                                <tr>
                                    <td  className = "makingbold">ZipCode/PostCode</td>
                                    <td   >942,272</td>
                                </tr>
                                <tr>
                                    <td  className = "makingbold">Address</td>
                                    <td   >Township Lahore Near Nursery Stop</td>
                                </tr>
                                <tr>
                                    <td  className = "makingbold">Mobile</td>
                                    <td   >03044993905</td>
                                </tr>
                                <tr>
                                    <td  className = "makingbold">Email</td>
                                    <td   >safgillani@gmail.com</td>
                                </tr>
                                <tr>
                                    <td  className = "makingbold">Date Applied</td>
                                    <td   >30/05/2020</td>
                                </tr>
                                <tr>
                                    <td className = "makingbold">Amount Owed</td>
                                    <td>&#163; 0.00 <i class="fa fa-info-circle"></i></td>
                                </tr>
                                <tr>
                                    <td className = "makingbold">Amount Paid</td>
                                    <td>&#163; 1952.40 <i class="fa fa-info-circle"></i></td>
                                </tr>
                                <tr>
                                    <td className = "makingbold">Profile Completion</td>
                                    <td>53%</td>
                                </tr>
                                <tr>
                                    <td className = "makingbold">Average Review Rating</td>
                                    <td><span><i class="fa fa-star checked"> 0.00</i></span>(No Reviews)</td>
                                </tr>
                        </table>                             
                        <table>
                                <tr>
                                    <th>Rate</th>
                                    <th></th>
                                </tr>

                                <tr>
                                    <td className = "makingbold">Tutor rate</td>
                                    <td>&#163; 25</td>
                                </tr>
                                <tr>
                                    <td className = "makingbold">Service fee</td>
                                    <td>&#163; 5</td>
                                </tr>
                        </table>
                        <table>
                                <tr>
                                    <th>Experience</th>
                                    <th></th>
                                </tr>

                                <tr>
                                    <td className = "makingbold" >Teaching or Tutoring</td>
                                    <td   >Between 1-4 years</td>
                                </tr>
                        </table>
                        <table>
                                <tr>
                                    <th>Account Details</th>
                                    <th></th>
                                </tr>

                                <tr>
                                    <td className = "makingbold" >Account name</td>
                                    <td   >Chisrtopher Zion</td>
                                </tr>
                                <tr>
                                    <td className = "makingbold" >Bank account sort code</td>
                                    <td   >242020</td>
                                </tr>
                                <tr>
                                    <td className = "makingbold" >Account number</td>
                                    <td   >24536202</td>
                                </tr>
                                <tr>
                                    <td className = "makingbold" >Postcode</td>
                                    <td   >L15 2HU</td>
                                </tr>
                                <tr>
                                    <td className = "makingbold" >Biling address</td>
                                    <td   >Somewhere Abroad</td>
                                </tr>
                        </table>

                        <table>
                                <tr>
                                    <th>Emergency Contact</th>
                                    <th></th>
                                </tr>

                                <tr>
                                    <td className = "makingbold" >Name</td>
                                    <td   >Chisrtopher Zion</td>
                                </tr>
                                <tr>
                                    <td className = "makingbold" >Relationship</td>
                                    <td   >242020</td>
                                </tr>
                                <tr>
                                    <td className = "makingbold" >Email</td>
                                    <td   >24536202</td>
                                </tr>
                                <tr>
                                    <td className = "makingbold" >Contact</td>
                                    <td   >L15 2HU</td>
                                </tr>
                        </table>

                        <table className = "Differentdata">
                            <tr>
                                <th>Activity Feed</th>
                                <th></th>
                            </tr>

                            <tr>
                                <td className = "makingbold" >Chris .<span id = "settingfont"> Edited a Note</span></td>
                                <td>19/06/2020<br/>14:30</td>
                            </tr>
                            <tr>
                                <td className = "makingbold" >Chris .<span id = "settingfont"> Added a Note</span></td>
                                <td>19/06/2020<br/>14:30</td>
                            </tr>
                            <tr>
                                <td className = "makingbold" >
                                    Chris Akoo .<span id = "makingunderline">Changed this tutor's status</span><br/><span id = "settingcolor">Changes status from Pending to Approved</span></td>
                                <td>19/06/2020<br/>14:30</td>
                            </tr>
                            <tr>
                                <td className = "makingbold" >Diana Lafayette .<span id = "makingunderline">Created a Tutor </span><br/><span id = "settingcolor">Changes status from Approved to Pending</span> </td>
                                <td>19/06/2020<br/>14:30</td>
                            </tr>
                            <tr>
                                <td className = "makingbold" >View more info</td>
                                <td>19/06/2020<br/>14:30</td>
                            </tr>        
                    </table>
                    </Row>


                </Col>
                
                <Col lg={8} md={12} sm={12} xs={12} className = "settingrightcolumn">
                    <Row className="m-0">
                        <div class = "tutorbio">
                            
                        <h2>Tutor Bio</h2>


                        <h4>Tagline</h4>
                        <p>Passionate Maths and Physics tutor!</p>
                        <h4>About</h4>
                        <p>
                            I love to teach-Helping students understand complicated
                            concepts and ideas and of course, their success makes worthwhile.
                            I graduated from university of Liverpool, Liverpoop with a B.Sc 
                            in Mathematics with Finance. I am full-time tutor,teaching mathematics and
                            business-related subjects in GCSE and A Level for students in Liverpool and
                            surrounding areas. In addition to tutoring, I am responsible for overseeing the 
                            development of the A-Level GCSE math Curriculum for the small group tuition sessions
                            and contributes tremendously to the learning portal designed for students. Ultimately,
                            my strenght is in identifying with his students's learning style and adjusting his teaching
                            mathods to optimize the learning experience. In my spare time. I enjoy mathematical puzzles
                            and playing badminton.
                        </p>
                        <h4>Teaching Style</h4>
                        <p>I am determined to learn how I could help students who are not doing well in traditional
                            classroom settings. As a result, I tailor my sessions to each student's learning needs for individual
                            academic success 
                        </p>
                    </div>
                    </Row>

                    <Row className="m-0">
                        <div className = "taughtsubject table-responsive">
                            <h3>
                                Taught subject
                            </h3>
                            <table>
                                <tr>
                                    <th>Primary and early years</th>
                                    <th>Keys  stage 3</th>
                                    <th>GCSE</th>
                                    <th>A-level</th>
                                    <th>Degree</th>
                                    <th>Adult learner</th>
                                    <th>Professional</th>
                                </tr>
                                <tr>
                                    <td>Maths</td>
                                    <td>Maths</td>
                                    <td>Maths</td>
                                    <td>Maths</td>
                                    <td>Calculus</td>
                                    <td>Maths</td>
                                    <td>Personal statement help</td>
                                </tr>
                                <tr>
                                    <td>11+ Maths</td>
                                    <td></td>
                                    <td></td>
                                    <td>Further Maths</td>
                                    <td>Statistics</td>
                                    <td></td>
                                    <td></td>
                                </tr>
                                <tr>
                                    <td>Non-verbal reasoning</td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                </tr>
                            </table>
                            
                        </div>
                    </Row>

                    <Row className="m-0">

                        <div className="tutoringpreference">
                            <h3>Tutoring Preference</h3>
                            <h6>Mode of Tutoring<span> : On-line &amp; In-person</span></h6>
                            <hr></hr>
                            <h6>Distance<span> : Less than 5 miles from 124,Salisbury Road,L15 2HU, Liverpool, United Kingdom</span></h6>
                            
                        </div>
                    </Row>

                    <Row className="m-0">
                        <div className="lessonstable table-responsive">
                            <h3>Lessons</h3>
                            <button className={ activetab === 0 ? "activebutton active1" : "activebutton" } onClick={ () => this.setState({ activetab: 0 }) }>Upcoming</button>
                            <button className={ activetab === 1 ? "activebutton active1" : "activebutton" } onClick={ () => this.setState({ activetab: 1 }) }>Previous lessons</button>
                            <button className={ activetab === 2 ? "activebutton active1" : "activebutton" } onClick={ () => this.setState({ activetab: 2 }) }>Cancelled</button>
                            <div>The tutor doesnot have any upcoming lessons</div>
                            
                            <table>
                                <tr>
                                    <th>Status</th>
                                    <th>Subject</th>
                                    <th>Parent/Student</th>
                                    <th>Date</th>
                                    <th>Time</th>
                                    <th>Venue</th>
                                    <th>Rate</th>
                                    <th></th>
                                    <th></th>
                                </tr>
                                <tr>
                                    <td>Confirmeed</td>
                                    <td>Maths(GCSE)</td>
                                    <td>Jamal Keller</td>
                                    <td>29/02/2020</td>
                                    <td>13:30pm-<br/>15:00pm</td>
                                    <td>Online Classroom</td>
                                    <td>&#163; 22.00</td>
                                    <td><button >Options</button></td>
                                    <td></td>
                                </tr>
                                <tr>
                                    <td>Confirmeed</td>
                                    <td>Maths(GCSE)</td>
                                    <td>Jamal Keller</td>
                                    <td>29/02/2020</td>
                                    <td>13:30pm-<br/>15:00pm</td>
                                    <td>Online Classroom</td>
                                    <td>&#163; 22.00</td>
                                    <td><button >Options</button></td>
                                    <td></td>
                                </tr>
                                <tr>
                                    <td>Confirmeed</td>
                                    <td>Maths(GCSE)</td>
                                    <td>Jamal Keller</td>
                                    <td>29/02/2020</td>
                                    <td>13:30pm-<br/>15:00pm</td>
                                    <td>Online Classroom</td>
                                    <td>&#163; 22.00</td>
                                    <td><button >Options</button></td>
                                    <td></td>
                                </tr>
                                <tr>
                                    <td>Confirmeed</td>
                                    <td>Maths(GCSE)</td>
                                    <td>Jamal Keller</td>
                                    <td>29/02/2020</td>
                                    <td>13:30pm-<br/>15:00pm</td>
                                    <td>Online Classroom</td>
                                    <td>&#163; 22.00</td>
                                    <td><button >Options</button></td>
                                    <td></td>
                                </tr>
                                <tr>
                                    <td>Confirmeed</td>
                                    <td>Maths(GCSE)</td>
                                    <td>Jamal Keller</td>
                                    <td>29/02/2020</td>
                                    <td>13:30pm-<br/>15:00pm</td>
                                    <td>Online Classroom</td>
                                    <td>&#163; 22.00</td>
                                    <td><button >Options</button></td>
                                    <td></td>
                                </tr>
                                <tr>
                                    <td>Confirmeed</td>
                                    <td>Maths(GCSE)</td>
                                    <td>Jamal Keller</td>
                                    <td>29/02/2020</td>
                                    <td>13:30pm-<br/>15:00pm</td>
                                    <td>Online Classroom</td>
                                    <td>&#163; 22.00</td>
                                    <td><button >Options</button></td>
                                    <td><button >Location</button></td>
                                </tr>
                            </table>
                        </div>
                    </Row>
                    <Row className = "m-0">
                    <nav aria-label="Page navigation example">
                        <ul class="pagination">
                            <li class="page-item "><a class="page-link fa fa-angle-double-left" href="#"><span className="spacingicon">Previous</span></a></li>
                            <li class="page-item"><a class="page-link" href="#">1</a></li>
                            <li class="page-item"><a class="page-link" href="#">2</a></li>
                            <li class="page-item active"><a class="page-link" href="#">3</a></li>
                            <li class="page-item"><a class="page-link" href="#">4</a></li>
                            <li class="page-item"><a class="page-link" href="#">5</a></li>
                            <li class="page-item"><a class="page-link" href="#">6</a></li>
                            <li class="page-item"><a class="page-link" href="#">7</a></li>
                            <li class="page-item"><a class="page-link" href="#">8</a></li>
                            <li class="page-item"><a class="page-link" href="#">Next<span className="fa fa-angle-double-right spacingicon2"></span></a></li>
                        </ul>
                    </nav>
                        <div className="simple">Total:91</div>
                    </Row>
                    <Row className = "m-0">
                        <div className="tutorreview">
                            <h3>Tutor Reviews</h3>

                            <div>The tutor has no reviews</div>
                            <div className = "changecolor">Review by Katherine Brown<span class="dot"></span>
                                <span ><i class="fa fa-star checked"></i></span>
                                <span ><i class="fa fa-star checked"></i></span>
                                <span ><i class="fa fa-star checked"></i></span>
                                <span ><i class="fa fa-star checked"></i></span>
                                <span ><i class="fa fa-star-o unchecked"></i></span>
                                <span class="dot"></span>
                                <span className="controltime">6 hours</span>
                            </div> 
                            <hr/>
                            <div className = "changecolor">Review by Carrie Linder<span class="dot"></span>
                                <span ><i class="fa fa-star checked"></i></span>
                                <span ><i class="fa fa-star checked"></i></span>
                                <span ><i class="fa fa-star checked"></i></span>
                                <span ><i class="fa fa-star checked"></i></span>
                                <span ><i class="fa fa-star-o unchecked"></i></span>
                                <span class="dot"></span>
                                <span className="controltime">3 hours,45 mins</span>
                            </div> 
                            <hr/>
                            <div className = "changecolor">Review by Carrie Linder<span class="dot"></span>
                                <span ><i class="fa fa-star checked"></i></span>
                                <span ><i class="fa fa-star checked"></i></span>
                                <span ><i class="fa fa-star checked"></i></span>
                                <span ><i class="fa fa-star checked"></i></span>
                                <span ><i class="fa fa-star-o unchecked"></i></span>
                                <span class="dot"></span>
                                <span className="controltime">1 hours,45 mins</span>
                            </div> 
                            <hr/>
                            <div>View more info</div>
                        </div>
                    </Row>
                    <Row className="m-0">
                        <div className="skillsandexperience">
                        <h3>Skills and experiences</h3>
                        <div>Have you previously tutored these subjects? <span> :Yes</span></div>
                        <hr/>
                        <div>Do you have teaching certificates or qualifications?<span> :Yes</span></div>
                        </div>
                    </Row>
                    <Row className="m-0">
                        <div className = "education table-responsive">
                            <h3>
                                Education
                            </h3>
                            <table>
                                <tr>
                                    <th>Institution</th>
                                    <th>Qualification</th>
                                    <th>Attained Class</th>
                                    <th>Start Date</th>
                                    <th>End Date</th>
                                </tr>
                                <tr>
                                    <td>University of Liverpool</td>
                                    <td>B.Sc. Mathematics with Finance</td>
                                    <td>In-progress</td>
                                    <td>02/2014</td>
                                    <td>Present</td>
                                </tr>
                                <tr>
                                    <td>Askademia University</td>
                                    <td>B.Sc. Business</td>
                                    <td>1st Class honours</td>
                                    <td>02/2014</td>
                                    <td>02/2011</td>
                    
                                </tr>
                            </table>
                            
                        </div>
                    </Row>
                    
                    <Row className="m-0">
                        <div className = "education table-responsive">
                            <h3>
                                Work Experience
                            </h3>
                            <div>No work experience added by the tutor.</div>
                            <table>
                                <tr>
                                    <th>Company</th>
                                    <th>Title</th>
                                    <th>Start Date</th>
                                    <th>End Date</th>
                                </tr>
                                <tr>
                                    <td>Askademia Limited</td>
                                    <td>Community Outreach Office</td>
                                    <td>02/2014</td>
                                    <td>Present</td>
                                </tr>
                                <tr>
                                    <td>SSP Health Limited</td>
                                    <td>Finance Officer</td>
                                    <td>09/2016</td>
                                    <td>11/2018</td>
                                </tr>

                                </table>
                        </div>
                    </Row>



                    <Row className="m-0">

                        <div className = "skills table-responsive">
                            <h3>
                                Skills
                            </h3>
                            <div>
                            No qualification added by the tutor.
                            </div>
                            <table>
                                <tr>
                                    <th>Qualification</th>
                                    <th>Document Attached</th>
                                    <th></th>
                                    <th></th>
                                </tr>
                                <tr>
                                    <td>PGCE</td>
                                    <td className="changingattributes">PGCE certificate.pdf</td>
                                    <td>
                                    <DropdownButton
                                        id="dropdown-basic-button"
                                        className="dropdown"
                                        title={
                                            <span className="flex-between-center">
                                            <span className="value">
                                                {value ? value : "Set Status"}
                                            </span>
                                            <i className="fa fa-caret-down"></i>
                                            </span>
                                        }
                                        >
                                        {values && values.length ? (
                                            values.map((value, index) => {
                                            return (
                                                <Dropdown.Item
                                                className="dropdown-item"
                                                style={{ padding: "5px 15px" }}
                                                onClick={() =>
                                                    this.setState({ value: value })
                                                }
                                                key={index}
                                                >
                                                {value}
                                                </Dropdown.Item>
                                            );
                                            })
                                        ) : (
                                            <Dropdown.Item className="dropdown-item">No Data</Dropdown.Item>
                                        )}
                                    </DropdownButton>
                                    </td>
                                    <td><button type="save">Save</button></td>
                                </tr>
                                <tr>
                                    <td>University Professor</td>
                                    <td className="changingattributes">Professor document.pdf</td>
                                    <td>
                                    <DropdownButton
                                        id="dropdown-basic-button"
                                        className="dropdown"
                                        title={
                                            <span className="flex-between-center">
                                            <span className="value">
                                                {value ? value : "Set Status"}
                                            </span>
                                            <i className="fa fa-caret-down"></i>
                                            </span>
                                        }
                                        >
                                        {values && values.length ? (
                                            values.map((value, index) => {
                                            return (
                                                <Dropdown.Item
                                                className="dropdown-item"
                                                style={{ padding: "5px 15px" }}
                                                onClick={() =>
                                                    this.setState({ value: value })
                                                }
                                                key={index}
                                                >
                                                {value}
                                                </Dropdown.Item>
                                            );
                                            })
                                        ) : (
                                            <Dropdown.Item className="dropdown-item">No Data</Dropdown.Item>
                                        )}
                                    </DropdownButton>


                                    </td>
                                    <td></td>
                                </tr>
                                <tr>
                                    <td>University lecture</td>
                                    <td className="changingattributes">Professor document.pdf</td>
                                    <td>
                                    <DropdownButton
                                        id="dropdown-basic-button"
                                        className="dropdown"
                                        title={
                                            <span className="flex-between-center">
                                            <span className="value">
                                                {value ? value : "Set Status"}
                                            </span>
                                            <i className="fa fa-caret-down"></i>
                                            </span>
                                        }
                                        >
                                        {values && values.length ? (
                                            values.map((value, index) => {
                                            return (
                                                <Dropdown.Item
                                                className="dropdown-item"
                                                style={{ padding: "5px 15px" }}
                                                onClick={() =>
                                                    this.setState({ value: value })
                                                }
                                                key={index}
                                                >
                                                {value}
                                                </Dropdown.Item>
                                            );
                                            })
                                        ) : (
                                            <Dropdown.Item className="dropdown-item">No Data</Dropdown.Item>
                                        )}
                                    </DropdownButton>


                                    </td>
                                    <td></td>
                                </tr>

                                </table>
                        </div>
                    </Row>

                    <Row className="m-0">
                        <div className="websites">
                            <h3>Websites</h3>
                            <div>
                            No website added by the tutor.
                            </div>
                            <h6>Website1<span>:https/relentless.com     </span></h6>
                            <hr></hr>
                            <h6>Website2<span>:https/askad.com</span></h6>
                            
                        </div>
                    </Row>

                    <Row className="m-0">
                        
                        <div className = "tutoridentity table-responsive">
                            <h3>
                                Tutor Identity
                            </h3>
                            <table>
                                <tr>
                                    <th>Type</th>
                                    <th>Issuing country/region</th>
                                    <th>Document Attached</th>
                                    <th></th>
                                    <th></th>
                                </tr>
                               
                                <tr>
                                    <td>Driving License</td>
                                    <td>United Kingdom</td>
                                    <td className="changingattributes">drivinglicensefront.jpeg</td>
                                    <td className="changingattributes">drivinglicenseback.jpeg</td>
                                    <td>
                                    <DropdownButton
                                        id="dropdown-basic-button"
                                        className="dropdown"
                                        title={
                                            <span className="flex-between-center">
                                            <span className="value">
                                                {value ? value : "Set Status"}
                                            </span>
                                            <i className="fa fa-caret-down"></i>
                                            </span>
                                        }
                                        >
                                        {values && values.length ? (
                                            values.map((value, index) => {
                                            return (
                                                <Dropdown.Item
                                                className="dropdown-item"
                                                style={{ padding: "5px 15px" }}
                                                onClick={() =>
                                                    this.setState({ value: value })
                                                }
                                                key={index}
                                                >
                                                {value}
                                                </Dropdown.Item>
                                            );
                                            })
                                        ) : (
                                            <Dropdown.Item className="dropdown-item">No Data</Dropdown.Item>
                                        )}
                                    </DropdownButton>


                                    </td>
                                </tr>

                                </table>
                        </div>
                    </Row>

                    <Row className="m-0">
                        
                        <div className = "backgroundcheck table-responsive">
                            <h3>
                                Background check
                            </h3>
                            <table>
                                <tr>
                                    <th>Type</th>
                                    <th>DBS Update Service?</th>
                                    <th>Document Attached</th>
                                    <th></th>
                                    <th></th>
                                </tr>
                               
                                <tr>
                                    <td>DBS Certificate</td>
                                    <td>Yes</td>
                                    <td className="changingattributes">DBSFrontCertificatepd</td>
                                    <td className="changingattributes">DBSBackCertificatepd</td>
                                    <td>
                                    <DropdownButton
                                        id="dropdown-basic-button"
                                        className="dropdown"
                                        title={
                                            <span className="flex-between-center">
                                            <span className="value">
                                                {value ? value : "Set Status"}
                                            </span>
                                            <i className="fa fa-caret-down"></i>
                                            </span>
                                        }
                                        >
                                        {values && values.length ? (
                                            values.map((value, index) => {
                                            return (
                                                <Dropdown.Item
                                                className="dropdown-item"
                                                style={{ padding: "5px 15px" }}
                                                onClick={() =>
                                                    this.setState({ value: value })
                                                }
                                                key={index}
                                                >
                                                {value}
                                                </Dropdown.Item>
                                            );
                                            })
                                        ) : (
                                            <Dropdown.Item className="dropdown-item">No Data</Dropdown.Item>
                                        )}
                                    </DropdownButton>
                                 

                                    </td>
                                </tr>

                                </table>
                        </div>
                    </Row>
                  <Row className="m-0">
                        <div className="notifications">
                            <h3>Notifiaction</h3>
                            <h6>New requests and upcoming lessons<span>: Text messages ,Email     </span></h6>
                            <hr/>
                            <h6>Messages<span>: Text messages ,Email</span></h6>
                            <hr/>
                            <h6>Lesson and feedback reminders<span>: Text messages ,Email</span></h6>
                            <hr/>
                            <h6>Job oppurtunities<span> :Email</span></h6>
                            <hr/>
                            <h6>Updates and Promotions<span>: Text messages ,Email</span></h6>
                            <hr/>
                            <h6>unsubscribe from all marketing emails<span>: Yes</span></h6>
                            
                        </div>
                    </Row>
                    <Row className="m-0">
                        <div className="policies">
                            <h3>Askademia Policies</h3>
                            <h6>I am eligible to work or possess the relevant immigration status to work in the UK on self-employed basis. Learn more 
                            about <span className="changecolor">UK self-employment law</span> <span>:Yes</span></h6>
                            <hr/>
                            <h6>I confirm that my descriptions and documents supplied are my own, and accurately reflect my tutoring sessions<span>:Yes</span></h6>
                            <hr/>
                            
                            <h6>I agree to the <span className="changecolor">Askademia Tutoring Terms and Service</span> and <span  className="changecolor">Refund Policy</span></h6>
                            
                        </div>
                    </Row>
                    


                    <Row>
                        <Col lg={6} md={6} sm={12} xs={12}>
                        <div className="notes">
                        <h3>Notes<img src={require("./../../assets/images/plus.png")}></img></h3>
                        <div>Add notes here</div>
                        <hr/>
                        <div>
                        <span>19/06/2020 13:30 </span>   .Induction has been carried out with 
                        tutor todiscuss with supervisor about outc...
                        <div className="imagealign"><img src={require("./../../assets/images/edit.png")}></img>
                        <img src={require("./../../assets/images/close1.png")}></img> </div>
                        </div>
                        </div>
                        </Col>

                        <Col lg={6} md={6} sm={12} xs={12}>
                        <div className="documents">
                        <h3>Documents<img src={require("./../../assets/images/cloud-computing.png")}></img></h3>
                        <div>Upload files here</div>
                        <hr/>
                        <div className="screenshot">
                        <span>Screen Shot 2020-06-19 at 09.29.58.png </span> . 19/06/2020
                        <img src={require("./../../assets/images/download.png")}></img>
                        </div>
                        <div className="screenshot">
                        <span>Screen Shot 2020-06-19 at 09.29.58.png </span> . 19/06/2020
                        <img src={require("./../../assets/images/download.png")}></img>
                        </div>
                        </div>
                        </Col>
                    </Row>
                    <Row className="m-0">
                        <div className = "taughtsubject" style={{width:"1600px"}}>
                            <h3>
                                Related Emails
                            </h3>
                            <div>There are no messages</div>
                            <table>
                                <tr>
                                    <th>Subject</th>
                                    <th>Status</th>
                                    <th>Send time</th>
                                </tr>
                                <tr>
                                    <td>Tutor has been approved by Administrator</td>
                                    <td>Sent</td>
                                    <td>3 hours ago</td>
                                </tr>

                                </table>
                        </div>
                    </Row>
                    
                    
                    <Row className = "m-0">
                        <div className="payment">
                            <h3>Payment Orders</h3>
                            <div>No payments orders.</div>
                            <div>
                                <span className="po"> PO - draft - 2447121</span>
                                <span class="dot"></span>
                                Status:<span className='fontbold'> Draft<span class="dot"></span></span>
                                Amout: <span className='fontbold'>&#163;290.00</span>
                            </div>
                                <hr/>
                            <div>
                                <span className="po">
                                PO - 47</span>
                                <span class="dot"></span>
                                Status:<span className='fontbold'> Unpaid<span class="dot"></span></span>
                                Amout: <span className='fontbold'>&#163;215.00</span>
                            </div>
                                <hr/>
                            <div >
                                <span className='po'>PO - 41</span>
                                
                                <span class="dot"></span>
                                Status:<span className='fontbold'> Paid<span class="dot"></span></span>
                                Amout: <span className='fontbold'>&#163;436.50</span>
                            </div>
                                 <hr/>
                            <div >
                                <span className='po'>PO - 31</span>
                                
                                <span class="dot"></span>
                                Status:<span className='fontbold'> Paid</span>
                                <span class="dot"></span>
                                Amout: <span className='fontbold'>&#163;280.00</span>
                            </div>
                            <hr/>
                            <div className='po'>View more info</div>
                            
                        </div>
                    </Row>

                </Col>
                
            </Row>

            
 
            {/* Starting the right side of the page..................... */}




            </div>
        )

    }

}

export default AdminSpecificTutor;